// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'

import MultiSelect from '../controls/MultiSelect'
import ErrorText from '../controls/ErrorText'
import type { GroupedOptionType } from '../types'

const t = {
  audiences: 'Аудитории',
  audience_select_placeholder: 'Выберите аудитории...',
  no_results_text: 'Нет аудиторий'
}

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`
const Header: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  vertical-align: top;
  padding-bottom: 4px;
`

type Props = {|
  options: Array<GroupedOptionType>,
  onChange: (Array<number>) => void,
  value: Array<number>,
  errors: Array<string>,
  hideHeader: boolean
|}

export default class AudiencesSelector extends Component<Props> {
  render() {
    return (
      <Wrapper>
        {!this.props.hideHeader && <Header>{t.audiences}</Header>}
        <MultiSelect
          value={this.props.value}
          options={[]}
          groupedOptions={this.props.options}
          className="t-Audiences"
          placeholder={t.audience_select_placeholder}
          onChange={(ids) => this.props.onChange(ids)}
          isClearable
          selectAll
          noResultsText={t.no_results_text}
        />
        <ErrorText errors={this.props.errors} />
      </Wrapper>
    )
  }
}
